module.exports = __webpack_public_path__ + "static/media/contact.06701ede.svg";